export function extractImpersonationToken(hash) {
  if (!String(hash || '').startsWith('#')) return null;
  return new URLSearchParams(String(hash).slice(1)).get('token');
}

export function readJwtClaims(token) {
  const payload = String(token || '').split('.')[1];
  if (!payload) throw new Error('Token de impersonación inválido');
  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
  return JSON.parse(window.atob(padded));
}

export function activateImpersonationSession({ token, store, storage = window.localStorage }) {
  const claims = readJwtClaims(token);
  if (!claims.impersonation || claims.scope !== 'store:read' || String(claims.uid) !== String(store._id)) {
    throw new Error('La sesión no es una impersonación válida de solo lectura');
  }

  storage.removeItem('refreshToken');
  storage.setItem('token', token);
  storage.setItem('store', String(store._id));
  storage.setItem('origin', String(store.origin || ''));
  storage.setItem('supportImpersonation:v1', JSON.stringify({
    storeId: String(store._id),
    storeName: store.storeName || store.name || store.mail || String(store._id),
    expiresAt: claims.exp,
    readOnly: true,
  }));
}
